import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setDataDashboard, getHistoric, getInfoProcess, getSubjectData, setReviewService, setEmissionService,getStatusList, getCausesRevoke, setRevokeFile, getCausesReject, setRejectProcess, getIssueFile } from './dashboardAPI';

const initialState = {
  historic: [],
  list: [],
  infoResultReview: [],
  infoProcess: '',
  subjectProcess: [],
  status: 'idle',
  statusHistoric: 'idle',
  statusProcess: 'idle',
  statusSubject: 'idle',
  statusProcessReview: 'idle',
  statusProcessEmission: 'idle',
  infoResultEmission: 'idle',
  statusResetWithFiltes:"idle",
  resetWithFilters :"idle",
  loaderMassive : "open",
  statusListFilter :"idle",
  listFilter: [],
  statusCauses:"idle",
  listCauses: [],
  statusSendFile : "idle",
  infoResultSendFile: [],
  statusCertificateFile : "idle",
  certificateFile: [],

  statusRejectReason : "idle",
  reasonsRejected : [],

  statusRejectProcess : "idle",
  rejectProcess : ""
};

export const dataDashboard = createAsyncThunk(
  '/dashboard',
  async (data) => {
    const response = await setDataDashboard(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);
export const rejectProcess = createAsyncThunk(
  '/dashboard/rejectProcess',
  async (data) => {
    const response = await setRejectProcess(data);
    if(!response.status && response.statusDescription) throw new Error(response.statusDescription)
    if (!response.status) throw new Error("Ha ocurrido un error inesperado")
    return response.data.data.responseMessage;
  }
);
export const getReasonReject = createAsyncThunk(
  '/dashboard/rejectedReason',
  async () => {
    const response = await getCausesReject();
    if (!response.data.data) throw new Error(response.data.error)
    return response.data.data;
  }
);

export const getlistFilter = createAsyncThunk(
  '/dashboard/listFilter',
  async (data) => {
    const response = await getStatusList(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);


export const getHistorick = createAsyncThunk(
  'dashboard/historic',
  async (data) => {
    const response = await getHistoric(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const resetWithFilters = createAsyncThunk(
  'dashboard/resetTable',
  async (data) => {
    return data;
  }
);

export const loaderMassive = createAsyncThunk(
  'dashboard/loaderMassive',
  async (data) => {
    return data;
  }
);

export const getSubjectDataUnique = createAsyncThunk(
  'dashboard/subject',
  async (data) => {
    const response = await getSubjectData(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const getReviewService = createAsyncThunk(
  'dashboard/review',
  async (data) => {
    const response = await setReviewService(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const getEmissionService = createAsyncThunk(
  'dashboard/emission',
  async (data) => {
    const response = await setEmissionService(data);
    if (!response) throw ({ message: response.data })
    return response.statusDescription ? response : response.data;
  }
);

export const getInfoProcessUnique = createAsyncThunk(
  'dashboard/process',
  async (data) => {
    const response = await getInfoProcess(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const getListCausesRevoke = createAsyncThunk(
  'dashboard/causesRevoke',
  async () => {
    const response = await getCausesRevoke();
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const getSendRevokeFile = createAsyncThunk(
  'dashboard/sendrevokefile',
  async (data) => {
    const response = await setRevokeFile(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const getCertificateFile = createAsyncThunk(
  'dashboard/DownloadCertificateFile',
  async (data) => {
    const response = await getIssueFile(data);
    if (!response.data) throw new Error( response.statusDescription )
    return response.data;
  }
);

const getListFilterOverride = (list)=>{
  let filterList = [];
  for (let index = 0; index < list.length; index++) {
    const element = list[index];
    filterList.push({
      "value":element.serviceStatusId,
      "label":element.name
    })
  }
  return filterList.sort(function(a, b) {
    const labelA = a.label.toUpperCase(); // ignore upper and lowercase
    const labelB = b.label.toUpperCase(); // ignore upper and lowercase
    if (labelA < labelB) {
      return -1;
    }
    if (labelA > labelB) {
      return 1;
    }
    return 0;
  });
}
export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    reset: () => initialState,
    resetReviewEmission: (state) => {
      state.statusProcessReview = 'idle'
      state.statusProcessEmission = 'idle'
      state.infoResultReview = []
      state.infoResultEmission = 'idle'
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(dataDashboard.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(dataDashboard.fulfilled, (state, action) => {
        state.status = 'finished';
        state.list = action.payload;
      })
      .addCase(dataDashboard.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(getHistorick.pending, (state) => {
        state.statusHistoric = 'loading';
      })
      .addCase(getHistorick.fulfilled, (state, action) => {
        state.statusHistoric = 'finished';
        state.historic = action.payload;
      })
      .addCase(getHistorick.rejected, (state, action) => {
        state.statusHistoric = 'failed';
      })
      .addCase(getInfoProcessUnique.pending, (state) => {
        state.statusProcess = 'loading';
      })
      .addCase(getInfoProcessUnique.fulfilled, (state, action) => {
        state.statusProcess = 'finished';
        state.infoProcess = action.payload;
      })
      .addCase(getInfoProcessUnique.rejected, (state, action) => {
        state.statusProcess = 'failed';
      })
      .addCase(getListCausesRevoke.pending, (state) => {
        state.statusCauses = 'loading';
      })
      .addCase(getListCausesRevoke.fulfilled, (state, action) => {
        state.statusCauses = 'finished';
        state.listCauses = action.payload;
      })
      .addCase(getListCausesRevoke.rejected, (state, action) => {
        state.statusCauses = 'failed';
      })
      .addCase(getReviewService.pending, (state) => {
        state.statusProcessReview = 'loading';
      })
      .addCase(getReviewService.fulfilled, (state, action) => {
        state.statusProcessReview = 'finished';
        state.infoResultReview = action.payload;
      })
      .addCase(getReviewService.rejected, (state, action) => {
        state.statusProcessReview = 'failed';
      })
      .addCase(getEmissionService.pending, (state) => {
        state.statusProcessEmission = 'loading';
      })
      .addCase(getEmissionService.fulfilled, (state, action) => {
        state.statusProcessEmission = 'finished';
        state.infoResultEmission = action.payload;
      })
      .addCase(getEmissionService.rejected, (state, action) => {
        state.statusProcessEmission = 'failed';
      })
      .addCase(getSubjectDataUnique.pending, (state) => {
        state.statusSubject = 'loading';
      })
      .addCase(getSubjectDataUnique.fulfilled, (state, action) => {
        state.statusSubject = 'finished';
        state.subjectProcess = action.payload;
      })
      .addCase(getSubjectDataUnique.rejected, (state, action) => {
        state.statusSubject = 'failed';
      })
      .addCase(resetWithFilters.pending, (state) => {
        state.statusResetWithFiltes = "pending";
      })
      .addCase(resetWithFilters.fulfilled, (state, action) => {
        state.statusResetWithFiltes = "fullfilled";
        state.resetWithFilters = action.payload;
      })
      .addCase(resetWithFilters.rejected, (state) => {
        state.statusResetWithFiltes = "rejected";
      })
      .addCase(loaderMassive.fulfilled, (state, action) => {
        state.loaderMassive = action.payload;
      })
      .addCase(getlistFilter.pending, (state) => {
        state.statusListFilter = "pending";
      })
      .addCase(getlistFilter.fulfilled, (state, action) => {
        state.statusListFilter = "fullfilled";
        state.listFilter =getListFilterOverride(action.payload);
      })
      .addCase(getlistFilter.rejected, (state) => {
        state.statusListFilter = "rejected";
      })
      .addCase(getSendRevokeFile.pending, (state) => {
        state.statusSendFile = 'loading';
      })
      .addCase(getSendRevokeFile.fulfilled, (state, action) => {
        state.statusSendFile = 'finished';
        state.infoResultSendFile = action.payload;
      })
      .addCase(getSendRevokeFile.rejected, (state, action) => {
        state.statusSendFile = 'failed';
      })

      .addCase(getReasonReject.pending, (state) => {
        state.statusRejectReason = 'loading';
      })
      .addCase(getReasonReject.fulfilled, (state, action) => {
        state.statusRejectReason = 'finished';
        state.reasonsRejected = action.payload;
      })
      .addCase(getReasonReject.rejected, (state, action) => {
        state.statusRejectReason = 'failed';
        state.rejectProcess = action.error.message;
      })

      .addCase(rejectProcess.pending, (state) => {
        state.statusRejectProcess = 'loading';
      })
      .addCase(rejectProcess.fulfilled, (state, action) => {
        state.statusRejectProcess = 'finished';
        state.rejectProcess = action.payload;
      })
      .addCase(rejectProcess.rejected, (state, action) => {
        state.statusRejectProcess = 'failed';
        state.rejectProcess = action.error.message;
      })
      
      .addCase(getCertificateFile.pending, (state) => {
        state.statusCertificateFile = 'loading';
      })
      .addCase(getCertificateFile.fulfilled, (state, action) => {
        state.statusCertificateFile = 'finished';
        state.certificateFile = action.payload;
      })
      .addCase(getCertificateFile.rejected, (state, action) => {
        state.statusCertificateFile = 'failed';
        state.certificateFile = action.error.message;
      })
  }
});

export const { reset, resetReviewEmission } = dashboardSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStatus = (state) => state.dashboard.status;
export const selectList = (state) => state.dashboard.list;
export const selectStatusHistoric = (state) => state.dashboard.statusHistoric;
export const selectHistoric = (state) => state.dashboard.historic;
export const selectStatusProcess = (state) => state.dashboard.statusProcess;
export const selectStatusSubject = (state) => state.dashboard.statusSubject;
export const selectInfoProcess = (state) => state.dashboard.infoProcess;
export const selectSubjectData = (state) => state.dashboard.subjectProcess;
export const selectInfoResult = (state) => state.dashboard.infoResultReview;
export const selectStatusReview = (state) => state.dashboard.statusProcessReview;
export const selectResultEmission = (state) => state.dashboard.infoResultEmission;
export const selectStatusEmission = (state) => state.dashboard.statusProcessEmission;
export const selectStatusResetWithFilter = (state) => state.dashboard.statusResetWithFiltes;
export const selectResetWithFilter = (state) => state.dashboard.resetWithFilters;
export const selectLoaderMassive = (state) => state.dashboard.loaderMassive;
export const selectStatusListFilter = (state) => state.dashboard.statusListFilter;
export const selectListFilter = (state) => state.dashboard.listFilter;
export const selectStatusCauses = (state) => state.dashboard.statusCauses;
export const selectListCauses = (state) => state.dashboard.listCauses;
export const selectStatusSendFile = (state) => state.dashboard.statusSendFile;
export const selectInfoResultSendFile = (state) => state.dashboard.infoResultSendFile;

export const selectStatusReasonProyT = (state) => state.dashboard.statusRejectReason;
export const selectRejectReasonsProyT = (state) => state.dashboard.reasonsRejected;

export const selectStatusRejectProyT = (state) => state.dashboard.statusRejectProcess;
export const selectRejectProcessProyT = (state) => state.dashboard.rejectProcess;
export const selectStatusCertificateFile = (state) => state.dashboard.statusCertificateFile;
export const selectCertificateFile = (state) => state.dashboard.certificateFile;
export default dashboardSlice.reducer;
